import { Box, Checkbox, FormControlLabel, Link, Typography } from '@mui/material';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import EmptyCheckbox from '../../../../assets/lernsets/icons/checkbox.svg';
import SelectedCheckbox from '../../../../assets/lernsets/icons/selectedCheckbox.svg';
import { palette, spaces } from '../../../../assets/styles/themes/tokens';
import { externalLinks } from '../../../../constants';

const CheckoutTerms: React.FC<{
	termsAccepted: boolean;
	onTermsChange: (value: boolean) => void;
	termsError: boolean;
	newsletter: boolean;
	onNewsletterChange: (value: boolean) => void;
}> = ({ termsAccepted, onTermsChange, termsError, newsletter, onNewsletterChange }) => {
	const { t } = useTranslation();

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: spaces.sm }}>
			<Box>
				<FormControlLabel
					sx={{
						'&.MuiFormControlLabel-root': {
							marginX: 0,
							alignItems: 'flex-start',
						},
					}}
					control={
						<Checkbox
							data-testid="stripe-checkout-terms"
							checked={termsAccepted}
							onChange={(e) => onTermsChange(e.target.checked)}
							color="primary"
							size="small"
							sx={{ paddingTop: 0 }}
							icon={<EmptyCheckbox />}
							checkedIcon={<SelectedCheckbox />}
						/>
					}
					labelPlacement="end"
					label={
						<Typography variant="caption" color={palette.text.secondary}>
							<Trans
								i18nKey={
									'I hereby declare that I have acknowledged and ' +
									'accepted the <0>AGB</0> and the <1>Widerrufsbelehrung</1>.'
								}
								components={[
									<Link key="0" href={externalLinks.tac} target="_blank" rel="noopener noreferrer">
										{t('AGB')}
									</Link>,
									<Link
										key="1"
										href={externalLinks.widerrufsbelehrung}
										target="_blank"
										rel="noopener noreferrer"
									>
										{t('Right of withdrawal')}
									</Link>,
								]}
							/>
						</Typography>
					}
				/>
				{termsError && (
					<Box sx={{ paddingLeft: spaces.md }}>
						<Typography
							variant="caption"
							color={palette.error.main}
							data-testid="stripe-checkout-terms-error"
						>
							{t('You have to agree to our terms and conditions')}
						</Typography>
					</Box>
				)}
			</Box>

			<FormControlLabel
				sx={{
					'&.MuiFormControlLabel-root': {
						marginX: 0,
						alignItems: 'flex-start',
					},
				}}
				control={
					<Checkbox
						data-testid="stripe-checkout-newsletter"
						checked={newsletter}
						onChange={(e) => onNewsletterChange(e.target.checked)}
						color="primary"
						size="small"
						sx={{ paddingTop: 0 }}
						icon={<EmptyCheckbox />}
						checkedIcon={<SelectedCheckbox />}
					/>
				}
				labelPlacement="end"
				label={
					<Box sx={{ display: 'flex', flexDirection: 'column', gap: spaces.md }}>
						<Typography variant="caption" color={palette.text.secondary}>
							{t(
								'Yes, I would like to receive the newsletter with free material recommendations,' +
									' tips for everyday school life, and exclusive invitations to webinars.' +
									' (Unsubscribable at any time).'
							)}
						</Typography>
						<Typography variant="caption" color={palette.text.secondary}>
							<Trans
								i18nKey="Our current <0>privacy policy</0> applies."
								components={[
									<Link key="0" href={externalLinks.dataPolicy} target="_blank" rel="noopener noreferrer">
										{t('privacyPolicy')}
									</Link>,
								]}
							/>
						</Typography>
					</Box>
				}
			/>
		</Box>
	);
};

export default CheckoutTerms;
